import { render, staticRenderFns } from "./LeaderDeptConfirm.vue?vue&type=template&id=6c65f771&"
import script from "./LeaderDeptConfirm.vue?vue&type=script&lang=js&"
export * from "./LeaderDeptConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports